import { Component, OnInit } from '@angular/core';
import {InicioFaces} from '../interfaces/inicioFaces';
import {InicioService} from '../services/inicio.service';
import { HttpClient, HttpEventType } from '@angular/common/http';
import{ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpHeaders } from '@angular/common/http';
import { AlertsService } from 'angular-alert-module';
import {thFaces} from '../interfaces/thFaces';





@Component({
  selector: 'app-galeria',
  templateUrl: './galeria.component.html',
  styleUrls: ['./galeria.component.css']
})
export class GaleriaComponent implements OnInit {

  albumesModel: InicioFaces[];
  inicioModel: InicioFaces[];


  API_ENDPOINT: string ='http://'+window.location.hostname+':3003';

  constructor(private inicioService: InicioService ,private httpClient: HttpClient,private formBuilder: FormBuilder,private _route: ActivatedRoute ,private alerts: AlertsService) { }


  listarExtenciones2() {
    this.inicioService.listarExtenciones().subscribe((data: any) => {
        this.inicioModel = data.obj.areas;
        console.log("qu sraaaa", data.obj);

        console.log("this.inicioModel", this.inicioModel);
       
        return;
    },
        (error) => {
            alert('Ocurrio un Error');
            console.log("imprimir", error);
        });
}

  ngOnInit() {
    this.listarExtenciones2();

  }
}